<template>
  <span class="edit-in-place">
    <span ref="text" @dblclick="editor()" v-show="!showInput">
      {{ data }}
      <span v-if="!data" class="placeholder">
        {{ placeholder }}
      </span>
    </span>
    <input
      type="text"
      ref="input"
      v-model="data"
      v-show="showInput"
      @blur="updateTextContent()"
      :placeholder="placeholder"
    />
  </span>
</template>

<script>
export default {
  name: 'EditInPlace',
  props: {
    value: String,
    placeholder: {
      type: String,
      default: '请点击输入'
    }
  },
  data() {
    return {
      showInput: false,
      data: ''
    };
  },
  mounted() {
    this.data = this.value;
  },
  methods: {
    editor() {
      this.showInput = true;
      this.$nextTick(() => {
        this.$refs['input'].focus();
      });
    },
    updateTextContent() {
      this.showInput = false;
      this.$emit('change', this.data);
    }
  },
  watch: {
    value: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.data = newValue;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.edit-in-place {
  background: transparent;
  border: none;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.39px;
  color: rgba(0, 0, 0, 0.65);
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  .placeholder {
    color: #75808B;
  }
  input {
    background: transparent;
    width: 100%;
    border: none;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: -0.39px;
    color: rgba(0, 0, 0, 0.65);
    display: inline-block;
  }
}
</style>
